export default function PrivacyPolicy() {
  return (
    <section className="page-shell legal-page">
      <div className="container">
        <div className="page-shell__content">
          <p className="page-eyebrow">Legal</p>
          <h1>Privacy Policy</h1>
          <p className="page-lead">
            This Privacy Policy explains how GEO_AI Systems handles information submitted through this website and related support forms.
          </p>

          <h2>Information We Collect</h2>
          <p>
            We may collect contact details, request descriptions, uploaded well log files, and technical information needed to process digitization requests and respond to support inquiries.
          </p>

          <h2>How We Use Information</h2>
          <p>
            Submitted information is used to evaluate requests, prepare digitization outputs, improve service quality, prevent abuse, and communicate with users about their submissions.
          </p>

          <h2>Uploaded Files</h2>
          <p>
            Uploaded PDF, TIFF, and LAS files are treated as request materials. Do not submit files unless you have the right to share them for processing.
          </p>

          <h2>Sharing and Retention</h2>
          <p>
            We do not sell personal information. Information may be shared with service providers only when necessary to operate, secure, or support the service. Data is retained only as long as needed for operational, legal, or support purposes.
          </p>

          <h2>Contact</h2>
          <p>
            Questions about privacy can be sent through the Contact Support page.
          </p>
        </div>
      </div>
    </section>
  );
}
